import { render, staticRenderFns } from "./UserOrgsAndIntegrations.vue?vue&type=template&id=3965ca5d&"
import script from "./UserOrgsAndIntegrations.vue?vue&type=script&lang=js&"
export * from "./UserOrgsAndIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./UserOrgsAndIntegrations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports